<div id="activities">
  <!-- <p style="margin: 10px; text-align: center;"><strong>{{ "SUMMARY.NOTE_ACTIVITIES" | translate }}</strong></p> -->
  <ng-container *ngFor="let day of days; let index = index">
    <app-optionals *ngIf="hasVisibleOptionals(day)" [day]="day" [showOptionlServices]="showOptionlServices" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImage"
      [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons" [hiddenCategories]="hiddenCategories"></app-optionals>
  </ng-container>
</div>